module.exports = ":host {\n  display: block;\n  color: #f8e71c;\n  font-size: 0.75em;\n}\n\nupd-fa-icon:not(:last-child) {\n  margin-right: 0.25em;\n}\n"